import React from 'react';
import PropTypes from 'prop-types';

import { BasicInput } from '../../../common/basic-input';
import { SecondaryButton } from '../../../common/secondary-button';
import { Validator } from '../../../helpers/Validator';
import { PasswordRecoveryController } from '../../../networking/controllers/PasswordRecoveryController';
import { routeNaming, goToPage } from '../../../routes';
import { SessionStore } from '../../../stores/SessionStore';

import styles from './DataForm.css';

const IPropTypes = {
  className: PropTypes.string,
  token: PropTypes.string.isRequired,
};

const defaultProps = {
  className: '',
};

class DataForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      error: false,

      password: '',
      passwordRepeat: '',

      passwordValid: false,
      passwordRepeatValid: false,
    };

    this._onSubmit = this._onSubmit.bind(this);
    this._updatePassword = this._updatePassword.bind(this);
    this._updatePasswordRepeat = this._updatePasswordRepeat.bind(this);
  }

  _updatePassword(event) {
    const { target: { value } } = event;
    this.setState(prevState => ({
      password: value,
      passwordValid: Validator.passwordIsValid(value),
      passwordRepeatValid: value === prevState.passwordRepeat,
    }));
  }

  _updatePasswordRepeat(event) {
    const { target: { value } } = event;
    this.setState(prevState => ({
      passwordRepeat: value,
      passwordRepeatValid: prevState.password === value,
    }));
  }

  async _onSubmit(event) {
    event.preventDefault();
    if (this.state.passwordValid && this.state.passwordRepeatValid) {
      PasswordRecoveryController.changePassword(this.state.password, this.props.token).then(() => {
        if (SessionStore.loggedIn) {
          // If the user has recovered the password successfully,
          // then they must be logged out of the current account
          SessionStore.logout();
        }
        goToPage(routeNaming.LOGIN);
      }).catch((error) => {
        if (error.response && error.response.status === 500) {
          this.setState({
            error: 'Ha ocurrido un error interno del servidor',
          });
        } else if (error.status === 401) {
          this.setState({
            error: `Por seguridad, el link enviado tiene un plazo de 2 horas.  
            Si todavía querés cambiar tu contraseña: Presioná nuevamente “olvidé mi contraseña”  
            en la página de Ingresar`,
          });
        } else {
          this.setState({
            error: error.message,
          });
        }
      });
    }
  }

  render() {
    const passwordError = !this.state.passwordValid &&
      this.state.password !== '' ? 'La contraseña debe tener al menos 6 caracteres' : null;
    const passwordRepeatError = !this.state.passwordRepeatValid &&
      this.state.passwordRepeat !== '' ? 'La contraseñas deben ser iguales' : null;
    return (
      <form
        className={this.props.className}
        onSubmit={this._onSubmit}
      >
        <BasicInput
          className={styles.input}
          label="Contraseña"
          name="password"
          type="password"
          error={passwordError}
          onChange={this._updatePassword}
        />
        <BasicInput
          className={styles.input}
          label="Repita la contraseña"
          name="passwordRepeat"
          type="password"
          error={passwordRepeatError}
          onChange={this._updatePasswordRepeat}
        />
        <SecondaryButton
          className={styles.button}
          type="submit"
          disabled={!this.state.passwordValid || !this.state.passwordRepeatValid}
        >
          CAMBIAR
        </SecondaryButton>
        {this.state.error &&
          <p className={styles.errorMessage}>
            {this.state.error}
          </p>}
      </form>
    );
  }
}

DataForm.propTypes = IPropTypes;
DataForm.defaultProps = defaultProps;

export { DataForm };



// WEBPACK FOOTER //
// ./src/pages/change-password/data-form/DataForm.jsx